var mainApplocationEntryPromise = import('../Entries/mainApplicationEntry');
//import initializeApplicationHelper from '../Entries/helperEntry';
var helperEntryPromise = import('../Entries/helperEntry');
//import initializeDestinationHotelList from "../Entries/destinationHotelListEntry";
var destinationHotelListEntryPromise = import('../Entries/destinationHotelListEntry');
//import initializeUtilities from "../Entries/utilitiesEntry";
var utilitiesEntryPromise = import('../Entries/utilitiesEntry');
var searchMaskEntryPromise = import('../Entries/searchMaskEntry');
//import initializeProgressBar from "Entries/progressBarEntry";
var progressBarEntryPromise = import('../Entries/progressBarEntry');
//import initializeFilterBarVertical from "Entries/filterBarVerticalEntry";
var filterBarVerticalEntryPromise = import('../Entries/filterBarVerticalEntry');
//import initializeRating from "../Entries/ratingEntry";
var ratingEntryPromise = import('../Entries/ratingEntry');
//import initializeRatingMobile from "../Entries/ratingMobileEntry";
var ratingMobileEntryPromise = import('../Entries/ratingMobileEntry');
//import initializeSunRating from "../Entries/sunRatingEntry";
var sunRatingEntryPromise = import('../Entries/sunRatingEntry');
//import initializeNavigation from "Entries/navigationEntry";
var navigationEntryPromise = import('../Entries/navigationEntry');
//import initializeGoogleMaps from "../Entries/googleMapsEntry";
var googleMapsEntryPromise = import('../Entries/googleMapsEntry');
//import initializeHotelCard from "../Entries/hotelCardEntry";
var hotelCardEntryPromise = import('../Entries/hotelCardEntry');
//import StoreSetup from "../Helper/StoreSetup";
var StoreSetupPromise = import('../Helper/StoreSetup');
//import initializeBurgerMenu from "../Entries/burgerMenuEntry";
var burgerMenuEntryPromise = import('../Entries/burgerMenuEntry');
//import initializeCouponElements from "../Entries/couponEntry";
var couponEntryPromise = import('../Entries/couponEntry');
//import initializePRGLink from "../Entries/prgLinkEntry";
var prgLinkEntryPromise = import('../Entries/prgLinkEntry');
//import initializeLanguageSwitcherLinks from "../Entries/languageSwitcherEntry";
var languageSwitcherEntryPromise = import('../Entries/languageSwitcherEntry');
//import initializeHotelGalleryUI from "Entries/hotelGalleryUIEntry";
var hotelGalleryUIEntryPromise = import('../Entries/hotelGalleryUIEntry');
var serviceWorkerDBEntryPromise = import('../Entries/serviceWorkerDBEntry');
import initializeServiceWorker from "../Entries/serviceWorkerEntry";
var hotelDetailBookmarkHeartEntryPromise = import('../Entries/hotelDetailBookmarkHeartEntry');
var loginEntryPromise = import('../Entries/loginEntry');
document.addEventListener('DOMContentLoaded', function () {
    document.body.className += ' loaded';
    setTimeout(function () {
        languageSwitcherEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        googleMapsEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        mainApplocationEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        burgerMenuEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        navigationEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        searchMaskEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        progressBarEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        filterBarVerticalEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        destinationHotelListEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        utilitiesEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        ratingEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        ratingMobileEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        sunRatingEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        hotelCardEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        couponEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        prgLinkEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        hotelDetailBookmarkHeartEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
        serviceWorkerDBEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }); });
        loginEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
    }, 0);
});
window.addEventListener('load', function () {
    initializeServiceWorker();
    helperEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
    hotelGalleryUIEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
    languageSwitcherEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
});
window.addEventListener('popstate', function (event) {
    location.reload();
});
